import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title max-sm-w-100" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1 max-sm-w-100" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar max-sm-w-100" }
const _hoisted_8 = {
  class: "d-flex flex-wrap justify-content-end gap-3 max-sm-w-100",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = {
  type: "button",
  class: "btn btn-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = { class: "me-0" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_14 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_15 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-250px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_16 = { class: "menu-item px-3" }
const _hoisted_17 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_18 = { class: "menu-item px-3" }
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_22 = { class: "menu-item px-3" }
const _hoisted_23 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_24 = { class: "menu-item px-3" }
const _hoisted_25 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_26 = { class: "menu-item px-3" }
const _hoisted_27 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_28 = { class: "menu-item px-3" }
const _hoisted_29 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_30 = { class: "card-body pt-0 vip-table" }
const _hoisted_31 = { class: "mb-1" }
const _hoisted_32 = { class: "fs-7 text-gray-400" }
const _hoisted_33 = { class: "mw-100px" }
const _hoisted_34 = { class: "text-gray-400 fs-7" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, "异常：订单无法验证", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle text-danger" }, null, -1)
const _hoisted_38 = {
  key: 1,
  class: "mw-100px"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "text-gray-400 fs-7" }
const _hoisted_41 = { class: "text-gray-400 fs-7" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "text-gray-400 fs-7" }
const _hoisted_44 = { class: "text-gray-400 fs-7" }
const _hoisted_45 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MBDatatable = _resolveComponent("MBDatatable")!
  const _component_exceptionModal = _resolveComponent("exceptionModal")!
  const _component_ImportModal = _resolveComponent("ImportModal")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-14 max-sm-w-100",
              placeholder: _ctx.t('common.search')
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
            }, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ], 512), [
              [_vShow, _ctx.search != '']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
            ]),
            _createVNode(_component_FilterDropdown, {
              onSubmitFilter: _ctx.handleFilter,
              onResetFilter: _ctx.handleFilterReset
            }, null, 8, ["onSubmitFilter", "onResetFilter"]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn btn-icon btn-bg-light btn-active-color-primary",
                "data-kt-menu-trigger": "click",
                "data-kt-menu-placement": "bottom-end",
                "data-kt-menu-flip": "top-end",
                disabled: 
                _ctx.disabledExportProgress ||
                _ctx.disabledExportPrintProgress ||
                _ctx.disabledForPurchaserReport ||
                _ctx.disabledForPurchaserReportPDF ||
                _ctx.loading
              
              }, [
                (
                  _ctx.disabledExportProgress ||
                  _ctx.disabledExportPrintProgress ||
                  _ctx.disabledForPurchaserReport ||
                  _ctx.disabledForPurchaserReportPDF
                )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                  : (_openBlock(), _createElementBlock("i", _hoisted_14))
              ], 8, _hoisted_12),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_permission_common, { role: { auth: ['import'] } }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t("common.import")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["menu-link px-3", {
                      disabled: _ctx.loading,
                    }]),
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_import_order_tracking",
                        style: {"font-size":"normal"}
                      }, _toDisplayString(_ctx.t("orderTracking.import")), 3)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("common.export")), 1)
                    ]),
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["menu-link px-3", {
                      disabled: _ctx.disabledExportProgress || _ctx.loading,
                    }]),
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fileExportProgress && _ctx.fileExportProgress(...args))),
                        style: {"font-size":"normal"}
                      }, [
                        (_ctx.disabledExportProgress && !_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("orderTracking.exportExcelReport")), 1)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["menu-link px-3", {
                      'opacity-50':
                        _ctx.disabledExportPrintProgress ||
                        _ctx.loading ||
                        _ctx.filterOptions.length === 0,
                      'cursor-nodrop':
                        _ctx.disabledExportPrintProgress ||
                        _ctx.loading ||
                        _ctx.filterOptions.length === 0,
                    }]),
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fileExportPrintProgress && _ctx.fileExportPrintProgress(...args))),
                        style: {"font-size":"normal"}
                      }, [
                        (_ctx.disabledExportPrintProgress && !_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("orderTracking.exportPdfReport")), 1)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["menu-link px-3", {
                      'opacity-50':
                        _ctx.disabledForPurchaserReport ||
                        _ctx.loading ||
                        _ctx.checkedIsCustomerFilter,
                      'cursor-nodrop':
                        _ctx.disabledForPurchaserReport ||
                        _ctx.loading ||
                        _ctx.checkedIsCustomerFilter,
                    }]),
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fileForPurchaserReport && _ctx.fileForPurchaserReport(...args))),
                        style: {"font-size":"normal"}
                      }, [
                        (_ctx.disabledForPurchaserReport && !_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("orderTracking.forPurchaserReport")), 1)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["menu-link px-3", {
                      'opacity-50':
                        _ctx.disabledForPurchaserReportPDF ||
                        _ctx.loading ||
                        _ctx.checkedIsCustomerFilter,
                      'cursor-nodrop':
                        _ctx.disabledForPurchaserReportPDF ||
                        _ctx.loading ||
                        _ctx.checkedIsCustomerFilter,
                    }]),
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fileForPurchaserReportPDF && _ctx.fileForPurchaserReportPDF(...args))),
                        style: {"font-size":"normal"}
                      }, [
                        (_ctx.disabledForPurchaserReportPDF && !_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("orderTracking.forPurchaserReportPDF")), 1)
                      ], 2)
                    ])
                  ]),
                  _: 1
                })
              ])
            ])), [
              [_directive_auth, { auth: ['export', 'import'] }]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_MBDatatable, {
          class: "max-sm-text-nowrap",
          loading: _ctx.loading,
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          "current-page": _ctx.currentPage,
          total: _ctx.total,
          "rows-per-page": _ctx.pageSize,
          onCurrentChange: _ctx.onCurrentPageChange,
          onItemsPerPageChange: _ctx.onRowsPerPageChange,
          onSort: _ctx.onColumnSort
        }, {
          "cell-order": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_31, _toDisplayString(item.order_number), 1),
            _createElementVNode("div", null, "SUB#" + _toDisplayString(item.position), 1),
            _createElementVNode("div", _hoisted_32, _toDisplayString(item.customer_name), 1)
          ]),
          "cell-product": _withCtx(({ row: item }) => [
            _createVNode(_component_product_info, {
              gallery: item.relation_sku.gallery,
              name: item.relation_sku.name,
              name_en: item.relation_sku.name_en,
              source_link: item.relation_sku.source_link,
              brand_id: item.relation_sku.brand
            }, null, 8, ["gallery", "name", "name_en", "source_link", "brand_id"])
          ]),
          "cell-sku": _withCtx(({ row: item }) => [
            _createVNode(_component_sku_info, {
              brand_article_no: 
              item.relation_sku.brand_article_no
                ? item.relation_sku.brand_article_no
                : item.relation_sku.merchant_article_no
            ,
              color: item.relation_sku.original_color,
              size: item.relation_sku.size,
              product_identifier_id: '0'
            }, null, 8, ["brand_article_no", "color", "size"])
          ]),
          "cell-ordered_qty": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(parseInt(item.ordered_qty)), 1)
          ]),
          "cell-current": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(item.node_date)), 1),
              _createElementVNode("div", _hoisted_34, _toDisplayString(item.node_name), 1)
            ])
          ]),
          "cell-next_step": _withCtx(({ row: item }) => [
            (item.next_date == '' && item.node_code != 6000)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createVNode(_component_el_popover, {
                    placement: "top",
                    width: "auto",
                    trigger: "hover"
                  }, {
                    reference: _withCtx(() => [
                      _hoisted_37
                    ]),
                    default: _withCtx(() => [
                      _hoisted_36
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  (item.delay_days)
                    ? (_openBlock(), _createBlock(_component_el_popover, {
                        key: 0,
                        placement: "top",
                        width: "auto",
                        trigger: "hover"
                      }, {
                        reference: _withCtx(() => [
                          (item.data_id)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass({
                    'text-warning': _ctx.isBigCurrentDate(item.next_date),
                    'text-decoration-underline': item.data_id,
                    'cursor-pointer': item.data_id,
                  }),
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modal_edit_exception",
                                onClick: ($event: any) => (_ctx.openModal(item))
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(item.next_date)), 1),
                                _createElementVNode("span", _hoisted_40, "(+" + _toDisplayString(item.delay_days) + ")", 1)
                              ], 10, _hoisted_39))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass({
                    'text-warning': _ctx.isBigCurrentDate(item.next_date),
                  })
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(item.next_date)), 1),
                                _createElementVNode("span", _hoisted_41, "(+" + _toDisplayString(item.delay_days) + ")", 1)
                              ], 2))
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(item.delay_reason), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (item.data_id)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass({
                  'text-warning': _ctx.isBigCurrentDate(item.next_date),
                  'text-decoration-underline': item.data_id,
                  'cursor-pointer': item.data_id,
                }),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#modal_edit_exception",
                              onClick: ($event: any) => (_ctx.openModal(item))
                            }, _toDisplayString(_ctx.formatDate(item.next_date)), 11, _hoisted_42))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass({
                  'text-warning': _ctx.isBigCurrentDate(item.next_date),
                })
                            }, _toDisplayString(_ctx.formatDate(item.next_date)), 3))
                      ], 64)),
                  _createElementVNode("div", _hoisted_43, _toDisplayString(item.next_node), 1)
                ]))
          ]),
          "cell-estimated_delivery_time": _withCtx(({ row: item }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["mw-100px", {
              'text-danger': _ctx.isBigDeliyDate(
                item.estimated_delivery_date,
                item.agreement_delivery_date
              ),
            }])
            }, [
              _createTextVNode(_toDisplayString(_ctx.formatDate(item.estimated_delivery_date)) + " ", 1),
              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.formatDate(item.agreement_delivery_date)) + "  ", 1)
            ], 2)
          ]),
          "cell-actions": _withCtx(({ row: item }) => [
            _createVNode(_component_router_link, {
              to: {
              name: 'mb-order-routing-order-tracking-information',
              params: {
                id: item.id,
                item_id: item.data_id,
              },
              query: {
                sku_id: item.sku_id,
                order_number_encry: item.order_number,
                ordered_qty: item.ordered_qty,
              },
            },
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_45, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange", "onSort"])
      ])
    ]),
    _createVNode(_component_exceptionModal, {
      dialogVisible: _ctx.dialogVisible,
      "onUpdate:dialogVisible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      data_ids: _ctx.data_ids,
      delay_days: _ctx.delay_days,
      delay_reason: _ctx.delay_reason,
      onResetForm: _ctx.closeModal,
      onUpdateList: _ctx.updateList
    }, null, 8, ["dialogVisible", "data_ids", "delay_days", "delay_reason", "onResetForm", "onUpdateList"]),
    _createVNode(_component_ImportModal, { onUpdateList: _ctx.updateList }, null, 8, ["onUpdateList"])
  ], 64))
}